// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"4f76454a","463":"725ae510"}[chunkId] + ".chunk.js";
};